import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';
import { ENV } from '../config/config';
const useGaTracker = () => {
	const location = useLocation();
	const [initialized, setInitialized] = useState<boolean>(false);

	useEffect(() => {
		if (!window.location.href.includes('localhost')) {
			ReactGA.initialize(`${ENV.gaTrackerId}`);
		}
		setInitialized(true);
	}, []);

	useEffect(() => {
		if (initialized) {
			ReactGA.pageview(location.pathname + location.search);
		}
	}, [initialized, location]);
};

export default useGaTracker;
